var $nav = document.querySelectorAll('.fjs-hamburger-menu'),
	$body = document.querySelector('body'),
	$menu = document.querySelector('.fjs-app-menu'),
	$overlay = document.querySelector('.fjs-app-overlay');

if($nav.length) {
	for(var i = 0; i < $nav.length; i++) {
		var $this = $nav[i];

		$this.addEventListener('click', function(e) {
			e.preventDefault();

			$body.classList.toggle('js-no-overflow');
			if($menu) {
				$menu.classList.toggle('js-is-hidden');
			}

			if($overlay) {
				$overlay.classList.toggle('js-is-hidden');
			}
		});
	}
}